import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { Policy } from '../../../types';

const getPolicy = (policyId: number) => {
  return get<Policy>(`/api/policies/${policyId}`);
};

const getQueryKeyForPolicy = (policyId: number): QueryKey => ['policy', policyId];

/**
 * hook for fetching one policy
 */
export default function useFetchPolicy(policyId: number) {
  return useQuery<Policy>({
    queryKey: getQueryKeyForPolicy(policyId),
    queryFn: () => getPolicy(policyId),
  });
}
